var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOfficeLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 140,
    viewBox: "0 0 140 140",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    "aria-label": "Kervolt Attendance",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 132,
    height: 132,
    rx: 30,
    fill: "#006a4e"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 34,
    width: 22,
    height: 22,
    rx: 5,
    fill: "#10b981"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59,
    y: 34,
    width: 22,
    height: 22,
    rx: 5,
    fill: "#10b981"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84,
    y: 34,
    width: 22,
    height: 22,
    rx: 5,
    fill: "#10b981"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 59,
    width: 22,
    height: 22,
    rx: 5,
    fill: "#10b981"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59 64a5 5 0 0 1 5-5h12a5 5 0 0 1 5 5v12a5 5 0 0 1-5 5H59V64z",
    fill: "#e8912d"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84,
    y: 59,
    width: 22,
    height: 22,
    rx: 5,
    fill: "#10b981"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 84,
    width: 22,
    height: 22,
    rx: 5,
    fill: "#10b981"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59,
    y: 84,
    width: 22,
    height: 22,
    rx: 5,
    fill: "#10b981"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84,
    y: 84,
    width: 22,
    height: 22,
    rx: 5,
    fill: "#ffffff",
    fillOpacity: 0.22
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOfficeLogo);
export default __webpack_public_path__ + "static/media/office-logo.b50a27884c66405ce1144ac548510bd2.svg";
export { ForwardRef as ReactComponent };